import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardContent, Divider, Stack, Typography, } from "@mui/material";
import { CountChip } from "../utils/CountChip";
// The shared list-card skeleton: Card > header(title + count + action) > Divider
// > rows (or empty state) > optional footer. Rows and footer are supplied by the
// caller so each card keeps its own entity row + links.
export function EntityListCard({ heading, count, title, headerAction, items, renderRow, emptyState, footer, }) {
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 2,
                    }, children: [title ?? (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: heading }), count !== undefined && _jsx(CountChip, { count: count })] })), headerAction] }), _jsx(Divider, { sx: { mb: 2 } }), _jsx(Stack, { spacing: 0, sx: { width: "100%" }, children: items.length > 0
                        ? items.map((item, index) => renderRow(item, index, items))
                        : emptyState }), footer] }) }));
}
